import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RegistrationFormInterface, FormDataErrorInterface } from "../domain";
import useRegistrationInfrastructure from "../infrastructure/hook/useRegistrationInfrastructure";
import { PhoneNumberUtil } from 'google-libphonenumber';

const useRegistration = (referrerId?: string) => {
    const {
        setRegisterFormInfrastructure,
        submitRegistrationInfrastructure,
        fetchDepartmentsInfrastructures,
        fetchCitiesByDepartmentInfrastructure,
        clearRegistrationErrorInfrastructure,
        setFormDataErrorInfrastructure,
        resetRegistrationStateInfrastructure,
        registrationState
    } = useRegistrationInfrastructure();
    const navigate = useNavigate();
    const phoneUtil = PhoneNumberUtil.getInstance();

    useEffect(() => {
        resetRegistrationStateInfrastructure();
        fetchDepartmentsInfrastructures();
    }, []);

    // Este useEffect se encargará de sincronizar el referrerId cada vez que cambie.
    useEffect(() => {
        setFormData({ referrerId: referrerId });
    }, [referrerId]);

    useEffect(() => {
        console.log("Department changed to ID:", registrationState.formData.department.id);
        if (registrationState.formData.department.id >= 0) {
            fetchCitiesByDepartmentInfrastructure(registrationState.formData.department.id);
        }
    }, [registrationState.formData.department.id]);

    useEffect(() => {
        if (registrationState.success && registrationState.responseRegistration.data?.phone) {
            resetRegistrationStateInfrastructure();
            navigate('/success/' + registrationState.responseRegistration.data.phone);
        }
    }, [registrationState.success, registrationState.responseRegistration])

    const handleSubmit = async () => {
        const { formData } = registrationState;
        const { name, email, phoneShow, policyAccepted } = formData;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // --- Inicio de Validaciones ---
        // Valida que el nombre tenga al menos dos palabras (nombre y apellido)
        if (!name || name.trim().split(' ').filter(n => n).length < 2) {
            console.log("entre por el name")
            setFormDataError({ ...registrationState.formDataError, name: true });
            return;
        }
        if (!email || !emailRegex.test(email)) {
            console.log("entre por el email")
            setFormDataError({ ...registrationState.formDataError, email: true });
            return;
        }
        if (!phoneShow || !isPhoneValid(phoneShow)) {
            console.log("entre por el phone")
            setFormDataError({ ...registrationState.formDataError, phone: true });
            return;
        }
        if (!policyAccepted) {
            console.log("entre por el policy")
            setFormDataError({ ...registrationState.formDataError, policyAccepted: true });
            return;
        }
        // --- Fin de Validaciones ---

        // La lógica de loading ahora es manejada por Redux.
        await submitRegistrationInfrastructure();
    };

    const setFormData = (formData: Partial<RegistrationFormInterface>) => { // Acepta un objeto parcial
        setRegisterFormInfrastructure(formData); // Lo pasa directamente
    }

    const setFormDataError = (formDataError: Partial<FormDataErrorInterface>) => {
        setFormDataErrorInfrastructure(formDataError);
    }

    const clearRegistrationError = () => {
        clearRegistrationErrorInfrastructure();
    }

    const isPhoneValid = (phone: string) => {
        try {
            const isValid = phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
            console.log("isValid", phone, isValid)
            return isValid;
        } catch (error) {
            return false;
        }
    };

    return {
        handleSubmit,
        setFormData,
        setFormDataError,
        clearRegistrationError,
        isPhoneValid,
        data: registrationState
    }
}

export default useRegistration;